import { useEffect, useState } from "react";
import { getTotalsByFilter } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import TiempoReporteModal from "./tiempoReporteModal";
import { FileUploadIcon } from "../../../components/icons/SvgIcons";

function FilterSecuestrosComponent({ fetchSecuestros }) {
  const dispatch = useDispatch();

  const [currentFilter, setCurrentFilter] = useState("todos");
  const [vehicleType, setVehicleType] = useState("todos");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const limit = useSelector((state) => state.limitSecuestros);
  const totalsByFilter = useSelector((state) => state.totalsByFilter);

  const FILTERS = {
    todos: {
      label: "Todos",
      message: "",
    },
    ingresados: {
      label: "Ingresados",
      message: "Vehículos que se encuentran actualmente en el corralón",
    },
    egresados: {
      label: "Egresados",
      message: "Vehículos que ya se entregaron",
    },
    "a compactar": {
      label: "A compactar",
      message: "Vehículos a compactar",
    },
    compactados: {
      label: "Compactados",
      message: "Vehículos que se compactaron",
    },
  };

  useEffect(() => {
    dispatch(getTotalsByFilter(vehicleType));
  }, [dispatch, vehicleType]);

  const buttonStyles = (type) =>
    currentFilter === type
      ? "bg-[#0a5477] text-white"
      : "bg-[#d7eaff] text-[#0477ad]";

  const setFilter = async (type) => {
    setCurrentFilter(type);

    await fetchSecuestros(
      1,
      type,
      vehicleType,
      limit
    );
  };

  const handleVehicleTypeChange = async (event) => {
    const selectedType = event.target.value;

    setVehicleType(selectedType);

    await fetchSecuestros(
      1,
      currentFilter,
      selectedType,
      limit
    );

    await dispatch(getTotalsByFilter(selectedType));
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div>
      {isModalOpen && (
        <TiempoReporteModal
          onClose={closeModal}
          currentFilter={currentFilter}
        />
      )}

      <div className="flex items-center flex-wrap">
        <div className="flex flex-wrap gap-2 justify-center sm:justify-start items-center p-4">
          {Object.entries(FILTERS).map(([key, config]) => (
            <button
              key={key}
              onClick={() => setFilter(key)}
              className={`px-1 py-1 rounded-sm inline-flex justify-center items-center transition-all duration-200 ${buttonStyles(
                key
              )}`}
            >
              <div className="font-semibold font-inter sm:text-[1rem] text-[0.7rem] whitespace-nowrap">
                {config.label ?? key}
              </div>

              <div className="ml-1 text-[0.8rem] sm:text-[0.95rem] font-bold px-2 py-[2px] rounded-sm">
                ({totalsByFilter[key] ?? 0})
              </div>
            </button>
          ))}
        </div>

        <div className="flex p-4 mx-5 justify-end items-center gap-3 font-inter text-[#3d4245] font-semibold">
          Tipo de vehículo:

          <select
            className="text-sm font-inter outline-none rounded-md sm:text-[1rem] text-[0.7rem] border border-[#0477AD] text-[#0477AD] font-semibold focus:outline-none focus:ring-0"
            value={vehicleType}
            onChange={handleVehicleTypeChange}
          >
            <option value="todos">Todos</option>
            <option value="Automóvil">Automóvil</option>
            <option value="Moto">Moto</option>
            <option value="Otro">Otro</option>
          </select>
        </div>
      </div>

      {currentFilter !== "todos" && (
        <div className="flex justify-center">
          <button
            onClick={openModal}
            className="mt-2 bg-green-600 hover:bg-green-700 text-white sm:text-[1.2rem] font-semibold font-inter px-3 py-1 rounded shadow flex"
          >
            <div className="flex">
              <FileUploadIcon className="size-6" />
              Excel
            </div>
          </button>
        </div>
      )}

      <div className="text-[#687073] sm:text-[1.1rem] text-s font-medium font-inter justify-center text-center px-4">
        {FILTERS[currentFilter]?.message ?? ""}
      </div>
    </div>
  );
}

export default FilterSecuestrosComponent;